<template>
  <div>
    <form-model title="签字面板" width="400" ref="formModel">
      <Button slot="btn" type="primary" @click="qianzi">提交签字</Button>
    </form-model>
  </div>
</template>
<script>
import fields from "./fields";
export default {
  data() {
    return {
      title: "",
      forms: [],
      item: {
        "formId": "",
        "title": "",
        "name": "",
        "role": "",
        "comment": "同意",
        "signTime": Date.now()
      },
      searchItem: { id: '' }
    };
  },
  methods: {
    reach(v) {
      console.log(v);
      this.forms = fields[v.key];
      this.item.title = v.title;
      this.item.role = v.nodeName;
      this.item.formId = v.docId; //表单id
      this.searchItem.id = v.docId;
      if (v.type == 'yanshouqianzi') {
        this.getFormModel(v.formId);
      }
      this.getUser();
      this.$refs.formModel.reach(this.forms, this.item);
    },
    open() {
      this.$refs.formModel.reach(this.forms, this.item);
    },
    qianzi() {
      this.utils.loading(this, "加载中");
      console.log(this.item);
   
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/approveComment/add",
        data: this.item,
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.$refs.formModel.close();
          this.$emit('ok');
        }
      });
    },
    getUser() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/account/getUserItem",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.item.name = this.utils.text(data.name, "");

      });
    },
    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.serverUrl + "/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log(res);
        if (res) {
          var data = res.data.data;
          if (data != null) {
            //this.item.title=data.acceptNo;
            this.item.formId = data.acceptId;
          }
        }
      });
    },
    getFormModel(id) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/form/info",
        data: { id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var v = res.data.data;
          this.serverUrl = v.serverUrl;
          this.getDetail();
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/wuliu/caiwufeiyong/qianzi.vue